/*
  <hm-row> — the shared carousel behaviour for every hm-* row section.

  Used by hm-product-row and hm-blog-row. Extracted rather than duplicated:
  these rows are the site's template system (Igor 2026-09-13), so the scroll
  logic has to live in ONE place or the two will drift.

  NOT Swiper. The wild band and the review band both stalled on Swiper's loop
  boundary on 2026-09-08 and each had to be rewritten as CSS. Native
  scroll-snap swipes correctly on touch, needs no library, and the arrows are
  two scrollBy calls.

  Contract, all optional so a row without arrows still works:
    [data-hm-row-track]  the scrolling element
    [data-hm-row-item]   the cards inside it
    [data-hm-row-prev]   previous button
    [data-hm-row-next]   next button
*/
if (!customElements.get('hm-row')) {
  customElements.define(
    'hm-row',
    class HmRow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hm-row-track]');
        this.prev = this.querySelector('[data-hm-row-prev]');
        this.next = this.querySelector('[data-hm-row-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });

        // The grid collapses to a single column on desktop, where the arrows are
        // display:none. Re-sync on resize so the disabled state is never stale
        // when someone rotates a phone or drags a window across the breakpoint.
        window.addEventListener('resize', () => this.sync(), { passive: true });

        this.sync();
      }

      step(dir) {
        const item = this.track.querySelector('[data-hm-row-item]');
        if (!item) return;
        // Card width plus the REAL computed gap, so one click advances exactly
        // one frame. Reading the gap rather than hardcoding it means a section
        // can change its spacing without breaking the step.
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({
          left: dir * (item.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      }

      sync() {
        const cs = getComputedStyle(this.track);
        const max = this.track.scrollWidth - this.track.clientWidth;
        // The track bleeds to the screen edge with a negative margin and an
        // equal inline padding, so `scroll-snap-type: x mandatory` parks the
        // resting position at the padding value, NOT at 0. Measured: scrollLeft
        // was 15 at rest against a 1.5rem padding, which left the previous
        // arrow enabled on a carousel that had not been scrolled.
        // So the floor is the padding, not zero.
        const floor = parseFloat(cs.paddingInlineStart) || 0;
        // 2px slack on top: sub-pixel scroll positions never land exactly on
        // either bound, and an exact comparison leaves an arrow live at the end.
        this.prev.disabled = this.track.scrollLeft <= floor + 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }
  );
}
